import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner } from '@/lib/macondo';
import { useAuth } from './AuthContext';
import { hasRole, type Role } from './roles';

/** Gate for signed-in routes; optionally a minimum role (UI only, the BFF enforces). */
export function RequireAuth({ children, role }: { children: ReactNode; role?: Role }) {
  const { status, user } = useAuth();
  const location = useLocation();
  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center" aria-busy="true">
        <Spinner />
      </div>
    );
  }
  if (status === 'anonymous') return <Navigate to="/login" replace state={{ from: location }} />;
  if (role && !hasRole(user?.role, role)) {
    return (
      <div className="p-800">
        <h1 className="text-h3 text-typography-primary">Not allowed</h1>
        <p className="text-callout text-typography-secondary mt-200">This page needs the {role} role.</p>
      </div>
    );
  }
  return <>{children}</>;
}
